import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { widgetContext } from '../../../context/widgetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function ButtonGroup(_ref) {
  var buttons = _ref.buttons,
      currentActiveValue = _ref.currentActiveValue,
      onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      testId = _ref.testId;

  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  var handleClick = React.useCallback(function (value) {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    "data-name": testId,
    children: buttons.map(function (_ref2, index) {
      var label = _ref2.label,
          value = _ref2.value;
      var TextComponent = isDesktop ? UIText2 : UIText1;
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: function onClick() {
          return handleClick(value);
        },
        className: cn(styles['button'], isDesktop && styles['desktop'], value === currentActiveValue && styles['active'], fullWidth && styles['button-equal-grow']),
        children: /*#__PURE__*/_jsx(TextComponent, {
          children: label
        })
      }, index);
    })
  });
}